import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function StFooter() {
    return (

        <footer className="ts-footer">
            <div className="container">
                <div className="row g-4">

                    <div className="col-lg-4 col-md-6">
                        <div className="ts-footer-brand">
                            <h3>TurboSteed</h3>
                            <p>The hosting platform for AI coding agents. Build, manage, and host — all from Claude Code.</p>

                            <div className="ts-social-links">
                                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/people/TurboSteed/61583976010878" aria-label="Facebook">
                                    <i className="fa fa-facebook"></i>
                                </a>
                                <a target="_blank" rel="noopener noreferrer" href="https://x.com/TurboSteed_web" aria-label="Twitter">
                                    <i className="fa fa-twitter"></i>
                                </a>
                                <a href="#" aria-label="Instagram">
                                    <i className="fa fa-instagram"></i>
                                </a>
                                <a href="#" aria-label="LinkedIn">
                                    <i className="fa fa-linkedin"></i>
                                </a>
                            </div>

                            <div className="mt-4">
                                <a href="https://aws.amazon.com/what-is-cloud-computing" target="_blank" rel="noopener noreferrer">
                                    <img src="https://d0.awsstatic.com/logos/powered-by-aws.png" alt="Powered by AWS Cloud Computing" style={{maxWidth: '100px', opacity: 0.8}} />
                                </a>
                            </div>
                        </div>
                    </div>


                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="ts-footer-links">
                            <h4>Features</h4>
                            <a href="/features/cms">CMS</a>
                            <a href="/features/contact-forms">Contact Forms</a>
                            <a href="/features/analytics">Analytics</a>
                            <a href="/features/asset-library">Asset Library</a>
                            <a href="/features/custom-domains">Custom Domains</a>
                            <a href="/features/api-access">API Access</a>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="ts-footer-links">
                            <h4>Documentation</h4>
                            <a href="/docs">Help Center</a>
                            <a href="/docs/user-guide">User Guide</a>
                            <a href="/docs/mcp-guide">MCP Guide</a>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="ts-footer-links">
                            <h4>Help</h4>
                            <a href="/terms.html">Terms</a>
                            <a href="mailto:support@turbosteed.com">Support</a>
                            <a href="/refund.html" target="_blank" rel="noopener noreferrer">Refund Policy</a>
                            <a href="/privacy.html" target="_blank" rel="noopener noreferrer">Privacy</a>
                            <a href="mailto:support@turbosteed.com">Report Abuse</a>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="ts-footer-links">
                            <h4>Company</h4>
                            <a href="/contactus">Contact</a>
                            <a href="/blogs">Blog</a>
                        </div>
                    </div>

                </div>

                <div className="ts-footer-bottom">
                    <p>&copy; {new Date().getFullYear()} TurboSteed. All rights reserved.</p>
                </div>
            </div>
        </footer>

    );

}

export default StFooter;
